import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Table, Spin, Select, DatePicker, Space, Form } from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { utils, writeFileXLSX } from "xlsx";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getUserList,
  getClientid,
  getUserInfo,
  getLocations,
} from "redux/selectors";
import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,
} from "common/Constants";
import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  addMonthinDate,
} from "utils/Date";
import COLORS from "common/Colors";
import { concat, find, get, includes, orderBy } from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { useTranslation } from "react-i18next";

const StyledTable = styled(Table)`
  padding-top: 20px;
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  a {
    color: #2d53da !important;
    :hover {
      color: #2d53da;
    }
    :active {
      color: #2d53da;
    }
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
  }
`;

const StyledButton = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;

const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 900px) {
    margin-left: -20px !important;
  }
  @media (max-width: 768px) {
    margin-left: -20px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;

const geoCache = new Map();
const geoInFlight = new Map();

const fetchAddress = (lat, lng) => {
  const key = `${lat},${lng}`;

  if (geoCache.has(key)) return Promise.resolve(geoCache.get(key));
  if (geoInFlight.has(key)) return geoInFlight.get(key);

  const promise = fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
    { headers: { "Accept-Language": "en" } }
  )
    .then((r) => r.json())
    .then((d) => {
      const a = d?.address;
      const label =
        a?.office ||
        a?.building ||
        a?.amenity ||
        a?.road ||
        a?.suburb ||
        a?.city ||
        d?.display_name?.split(",").slice(0, 2).join(", ") ||
        key;
      geoCache.set(key, label);
      geoInFlight.delete(key);
      return label;
    })
    .catch(() => {
      geoCache.set(key, key);
      geoInFlight.delete(key);
      return key;
    });

  geoInFlight.set(key, promise);
  return promise;
};

const useGeoAddress = (lat, lng) => {
  const key = lat && lng ? `${lat},${lng}` : null;

  const [address, setAddress] = React.useState(() =>
    key ? geoCache.get(key) ?? null : null
  );
  const [loading, setLoading] = React.useState(() =>
    key ? !geoCache.has(key) : false
  );

  React.useEffect(() => {
    if (!key) return;

    if (geoCache.has(key)) {
      setAddress(geoCache.get(key));
      setLoading(false);
      return;
    }

    let cancelled = false;
    fetchAddress(lat, lng).then((label) => {
      if (!cancelled) {
        setAddress(label);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [key]);

  return { address, loading };
};

const LocationCell = React.memo(({ lat, lng, hasother, locationName }) => {
  const hasCoords =
    lat != null &&
    lat !== "" &&
    lat !== undefined &&
    lng != null &&
    lng !== "" &&
    lng !== undefined;

  const { address, loading } = useGeoAddress(
    hasCoords ? lat : null,
    hasCoords ? lng : null
  );

  if (!hasCoords) return <span>-</span>;
  if (loading)
    return <span style={{ color: "#888", fontSize: 12 }}>Resolving…</span>;

  const mapUrl = `http://maps.google.com/maps/?q=${lat},${lng}`;
  return (
    <>
      <a href={mapUrl} target="_blank" rel="noreferrer">
        {hasother ? address : locationName}
      </a>
      <br />
      <span style={{ fontSize: "10px", color: "#ccc" }}>
        {lat}, {lng}
      </span>
    </>
  );
});

function AttendanceReport({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userList,
  userInfo,
  locationList,
}) {
  const { t, i18n } = useTranslation();
  console.log("locationList", locationList);

  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  const [form] = Form.useForm();
  const [filterList, setFilterList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(
      month_list?.map((item) => ({
        ...item,
        label: t(item?.label),
      }))
    );
  };

  const STAFF_LIST_ALL = attendanceList.map((val) => ({
    user_id: val.userid,
    name: val.fullname,
  }));

  for (let i = 0; i < STAFF_LIST_ALL.length; i++) {
    filterList.push(STAFF_LIST_ALL[i]);
  }

  const STAFF_LIST = [...new Set(filterList.map((a) => JSON.stringify(a)))].map(
    (a) => JSON.parse(a)
  );

  const filterattentancereport = attendanceList.filter((val) => {
    if (form.getFieldValue("staff_name") === "") {
      return val;
    } else if (val?.userid === form.getFieldValue("staff_name")) {
      return val;
    }
  });

  // ─── Table columns (visible table) ─────────────────────────────────────────

  const columns = [
    {
      title: t("Employee ID"),
      dataIndex: "employeeid",
      key: "employeeid",
      width: "7%",
    },
    {
      title: t("Employee Name"),
      dataIndex: "fullname",
      key: "fullname",
      width: "10%",
      render: (fullName) => {
        if (fullName !== ("" || null || undefined)) return fullName;
        return "-";
      },
    },
    {
      title: t("Department"),
      dataIndex: "departmentname",
      key: "departmentname",
      width: "10%",
      render: (departmentName) => {
        if (departmentName !== ("" || null || undefined)) return departmentName;
        return "-";
      },
    },
    {
      title: t("Checkin Station"),
      dataIndex: "loginlocationname",
      key: "loginlocationname",
      width: "10%",
      render: (loginlocationname) => {
        if (loginlocationname !== ("" || null || undefined))
          return loginlocationname;
        return "-";
      },
    },
    {
      title: t("Check-in date"),
      dataIndex: "checkindate",
      key: "checkindate",
      width: "7%",
      render: (checkinDate) => {
        if (checkinDate === ("" || null || undefined)) return "-";
        return moment(checkinDate).format("DD MMM YYYY");
      },
    },
    {
      title: t("Check-in day"),
      dataIndex: "checkindate",
      key: "checkindateday",
      width: "7%",
      render: (checkinDate) => {
        if (checkinDate === ("" || null || undefined)) return "-";
        return moment(checkinDate).format("dddd");
      },
    },
    {
      title: t("Check-in time"),
      dataIndex: "checkintime",
      key: "checkintime",
      width: "5%",
    },
    {
      // Check-in coordinates → shows resolved location name only
      title: t("Check-in Coordinates"),
      dataIndex: "loginlatitude",
      key: "loginlatitude",
      width: "10%",
      render: (_, record) => {
        const findLocation = locationList?.find(
          (item) => item?.location_id === String(record?.loginlocationid)
        );
        console.log("findLocation", findLocation);
        const hasother = findLocation?.login_from_anywhere === 1 ? true : false;
        console.log("hasother", hasother);
        return (
          <LocationCell
            lat={record.loginlatitude}
            lng={record.loginlongitude}
            hasother={hasother}
            locationName={record.loginlocationname}
          />
        );
      },
    },
    {
      title: t("Checkout Station"),
      dataIndex: "logoutlocationname",
      key: "logoutlocationname",
      width: "10%",
      render: (logoutLocationName) => {
        if (
          logoutLocationName === null ||
          logoutLocationName === "" ||
          logoutLocationName === undefined
        ) {
          return "-";
        }
        return logoutLocationName;
      },
    },
    {
      title: t("Check-out date"),
      dataIndex: "checkoutdate",
      key: "checkoutdate",
      width: "7%",
      render: (checkoutDate) => {
        if (
          checkoutDate === null ||
          checkoutDate === "" ||
          checkoutDate === undefined
        ) {
          return "-";
        }
        return moment(checkoutDate).format("DD MMM YYYY");
      },
    },
    {
      title: t("Check-out day"),
      dataIndex: "checkoutdate",
      key: "checkoutdateday",
      width: "7%",
      render: (checkoutDate) => {
        if (
          checkoutDate === null ||
          checkoutDate === "" ||
          checkoutDate === undefined
        ) {
          return "-";
        }
        return moment(checkoutDate).format("dddd");
      },
    },
    {
      title: t("Check-out time"),
      dataIndex: "checkouttime",
      key: "checkouttime",
      width: "5%",
      render: (checkoutDateTime) => {
        if (
          checkoutDateTime === null ||
          checkoutDateTime === "" ||
          checkoutDateTime === undefined
        ) {
          return "-";
        }
        return checkoutDateTime;
      },
    },
    {
      title: t("Check-out Coordinates"),
      dataIndex: "end_lat_long",
      key: "logoutlatitude",
      width: "10%",
      render: (_, record) => {
        const findLocation = locationList?.find(
          (item) => item?.location_id === String(record?.logoutlocationid)
        );
        const hasother = findLocation?.login_from_anywhere === 1 ? true : false;
        return (
          <LocationCell
            lat={record.logoutlatitude}
            lng={record.logoutlongitude}
            hasother={hasother}
            locationName={record.logoutlocationname}
          />
        );
      },
    },
  ];

  useEffect(() => {
    getAttendanceReport();
  }, [
    selectedDepartmentId,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
  ]);

  useEffect(() => {
    form.resetFields();
    list();
  }, [i18n.language]);

  const getAttendanceReport = async () => {
    list();
    return new Promise(async (resolve, reject) => {
      setAttendanceList([]);
      const { start_date, end_date, duration_type, month } =
        form.getFieldsValue();
      setDisplayTableLoader(true);
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(find(MONTH_LIST, { value: month }), "index", 0)
      );
      const { code, attendanceList = [] } = await CALL_API(
        `attendance-report/${ClientId}`,
        "post",
        {
          department: [""],
          start_date: getMySqlDate(
            duration_type === 2 ? startDateOfMonth : start_date
          ),
          end_date: getMySqlDate(
            duration_type === 2 ? lastDateOfMonth : end_date
          ),
          reportingmanager: userInfo?.userid,
        }
      );
      setDisplayTableLoader(false);
      if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
        const sortedData = attendanceList.sort((a, b) => {
          const timeA = moment(a.checkintime, "HH:mm:ss");
          const timeB = moment(b.checkintime, "HH:mm:ss");
          return timeB - timeA;
        });
        setAttendanceList(orderBy(sortedData, ["checkindatetime"], ["desc"]));
      }
    });
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const xport = React.useCallback(() => {
    const elt = document.getElementById("Table");
    const wb = utils.table_to_book(elt);
    writeFileXLSX(wb, "attendance-report.xlsx");
  });

  const paginationOptions = {
    showTotal: (total, range) =>
      `${range[0]}-${range[1]} ${t("of")} ${total} ${t("items")}`,
    pageSize: 100,
    showSizeChanger: false,
  };

  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                department: "",
              }}
              onFinish={getAttendanceReport}
            >
              <Form.Item
                name="duration_type"
                rules={[{ required: true, message: "" }]}
              >
                <Select
                  placeholder={t("Select...")}
                  options={REPORT_DURATION_TYPES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder={t("Start date")}
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder={t("End date")}
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      name="month"
                      rules={[{ required: true, message: "" }]}
                    >
                      <Select
                        placeholder={t("Select...")}
                        options={monthList}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>

              <Form.Item
                name="staff_name"
                rules={[{ required: false, message: "" }]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.name ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.name ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.name ?? "").toLowerCase())
                  }
                  placeholder={t("Select Employee")}
                  options={concat(
                    { user_id: "", name: t("All Employee") },
                    STAFF_LIST
                  )}
                  fieldNames={{ label: "name", value: "user_id" }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder={t("Select Department")}
                    options={concat(
                      {
                        department_id: "",
                        department_name: t("All Departments"),
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <StyledButtonoutlined
            onClick={xport}
            disabled={filterattentancereport.length === 0}
          >
            {t("Export XLSX file")}
          </StyledButtonoutlined>
        </Col>
      </Row>
      <br />
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false
          }
        />

        <Table
          style={{ display: "none" }}
          dataSource={filterattentancereport}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          pagination={false}
          id="Table"
        />
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userList: getUserList(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  locationList: getLocations(state),
});

export default connect(mapStateToProps, null)(AttendanceReport);
